import { createSlice } from "@reduxjs/toolkit";

import { readDocumentMetadata } from "./actions";

export const INITIAL_STATE = {
  error: false,
  fileName: null,
  fileType: null,
  fileSize: null,
  isInitialized: false,
  properties: {},
};

export const metadataSlice = createSlice({
  name: "metadata",
  initialState: INITIAL_STATE,
  reducers: {
    removeFromProperties: (state, { payload: key }) => {
      delete state.properties[key];
    },
    resetProperties: (state) => {
      state.properties = INITIAL_STATE.properties;
    },
    resetDocumentMetadata: () => INITIAL_STATE,
    setDocumentMetadata: (state, { payload = {} }) => {
      state.error = false;
      state.isInitialized = true;
      state.properties = payload;
    },
    setWorkspaceId: (state, { payload }) => {
      state.properties.workspaceId = payload ?? null;
    },
    setFileInfo: (state, { payload }) => {
      state.fileName = payload.fileName ?? null;
      state.fileType = payload.fileType ?? state.fileType;
      state.fileSize = payload.fileSize ?? state.fileSize;
    },
    setSyncBlockedState: (state, { payload }) => {
      Object.assign(state.properties, payload);
    },
  },
  extraReducers: (builder) => {
    // If reading the document's metada fails, still go ahead
    // and initialize the metadata anyway.
    builder.addCase(readDocumentMetadata.rejected, (state, action) => {
      state.error = action.error;
      state.isInitialized = true;
    });
  },
});

export const {
  removeFromProperties,
  resetProperties,
  resetDocumentMetadata,
  setDocumentMetadata,
  setWorkspaceId,
  setFileInfo,
  setSyncBlockedState,
} = metadataSlice.actions;
